import { Breakpoints, styled, Text, TokenTextAppearance, TokenTextColor, TextTag } from '@volkswagen-onehub/components-core';
import React from 'react';
import { IconSizeType, SVGProps } from '../../../types/svgs';
import { VolksKlickLogo } from './Logo';

const IconWrapper = styled.div<{iconSize ?: IconSizeType}>`
  overflow: auto;
  display: flex;
  width: ${props => props.iconSize ? props.iconSize.default : '64px'};
  @media (min-width: ${Breakpoints.b560}px) {
    width: ${props => props.iconSize ? props.iconSize.b560 : '100px'};
  }
  @media (min-width: ${Breakpoints.b1600}px) {
    width: ${props => props.iconSize ? props.iconSize.b1600 : '120px'};
  }
`;

const Container = styled.div<{color?: string;}>`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
  ${({color}) => color ? `color: ${color};` : ``}
`;

const PositionedText = styled(Text)`
  position: relative;
  transform: translateY(10%);
`;

export const VolksKlickLogotype = ({
  className,
  title,
  ariaHidden,
  ariaLabel,
  tabIndex,
  ref,
  color,
  appearance,
  iconSize
}: SVGProps) => {

  return (
    <Container color={color}>
      <IconWrapper iconSize={iconSize}>
        <VolksKlickLogo
          className={className}
          title={title}
          ariaHidden={ariaHidden}
          ariaLabel={ariaLabel}
          tabIndex={tabIndex}
          ref={ref}
        />
      </IconWrapper>
      <PositionedText
        tag={TextTag.p}
        appearance={appearance ? appearance : TokenTextAppearance.headline500}
        color={TokenTextColor.inherit}
      >
        Volks
        <Text tag={TextTag.span} bold>
          Klick
        </Text>
      </PositionedText>
    </Container>
  );
};

